const Types = {
    SEARCH_REQUEST: '@usuarios-preparacao/SEARCH_REQUEST',
    SEARCH_SUCCESS: '@usuarios-preparacao/SEARCH_SUCCESS',
    SEARCH_FAILURE: '@usuarios-preparacao/SEARCH_FAILURE',
    RECOVER_PREPARATIONS: '@usuarios-preparacao/RECOVER_PREPARATIONS',
    CREATE_PREPARATION: '@usuarios-preparacao/CREATE_PREPARATION',
    CREATE_SUCCESS: '@usuarios-preparacao/CREATE_SUCCESS',
    DELETE_PREPARATION: '@usuarios-preparacao/DELETE_PREPARATION',
    DELETE_SUCCESS: '@usuarios-preparacao/DELETE_SUCCESS'
};

export default Types;